export enum SliceStatusValue {
  idle = "idle",
  loading = "loading",
  resolve = "resolve",
  reject = "reject",
}
